<template>
  <div class="radio-group" :class="className">
    <dni-radio
      v-for="item in radioList"
      :id="utils.getIds(page, item.id)"
      :key="item.id"
      :name="name"
      :value="item.value"
      :label="$t(item.label)"
      :config.sync="choose"
      :disabled="disabled"
      @click="update"
    />
  </div>
</template>
<script>
export default {
  props: {
    config: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      name: "",
    },
    radioList: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "vertical", // 'horizontal'
    },
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      choose: "",
    };
  },
  watch: {
    config: {
      handler() {
        if (this.config) {
          this.choose = this.config;
        }
      },
      immediate: true,
    },
  },
  methods: {
    update() {
      this.$emit("update:config", this.choose);
      this.$emit("change");
    },
  },
};
</script>
<style lang="scss">
.radio-group {
  width: 100%;
  float: left;
}
.radio-group {
  .n-radio {
    display: block;
  }
}
.radio-group.horizontal {
  .n-radio {
    margin-right: 30px;
    float: left;
  }
}
</style>
